// Remove it completely

const ShortcutListing = (props) => {
  return <></>;
};

export default ShortcutListing;
